import UserStatusEnum from '@constants/enums/user/status';
import UserRoleEnum from '@constants/enums/user/role';

import i18n from '@plugins/i18n';

import { Collection, User } from '@/models';

export class UserCollection extends Collection {
    static type = 'UserCollection';
    static endpoint = User.api.index;
    static model = User;

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true,
                sortable: true,
                sticky: true
            }),
            this.createHeader('email', i18n.t('email'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true
            }),
            this.createHeader('roles', i18n.t('role'), {
                format: 'enum',
                enum: UserRoleEnum,
                enumA11yKey: 'enums.user_role',
                multiple: true,
                width: '11rem',
                transform: data => {
                    let roles = [];

                    if (data.item.roles) {
                        data.item.roles.forEach(role => {
                            roles.push(...role.roles);
                        });
                    }

                    return [...new Set([...roles])];
                }
            }),
            this.createHeader('status', i18n.t('status'), {
                filterable: true,
                width: '10rem',
                format: 'enum',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            })
        ];
    }
}

export default UserCollection;
